module.exports = __webpack_public_path__ + "static/20190327_iPhone-X-Mockup_2019_dashboard_mobile-d0b6ca4c9a8374f1abdeedaf39d9823e.jpg";